/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    AuthenticationType: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    Game: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    Locale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    SessionId?: string | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    SteamLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    SteamOpenIdLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    EgsLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    GoogleLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    FacebookLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    AuthenticateWithExternalIdGameAccessToken?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    AwAuthData?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    VkIdLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin | null;
}



/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    if (!('AuthenticationType' in value) || value['AuthenticationType'] === undefined) return false;
    if (!('Game' in value) || value['Game'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'AuthenticationType': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON(json['AuthenticationType']),
        'Game': json['Game'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
        'SessionId': json['SessionId'] == null ? undefined : json['SessionId'],
        'SteamLogin': json['SteamLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginFromJSON(json['SteamLogin']),
        'SteamOpenIdLogin': json['SteamOpenIdLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSON(json['SteamOpenIdLogin']),
        'EgsLogin': json['EgsLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginFromJSON(json['EgsLogin']),
        'GoogleLogin': json['GoogleLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSON(json['GoogleLogin']),
        'FacebookLogin': json['FacebookLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginFromJSON(json['FacebookLogin']),
        'AuthenticateWithExternalIdGameAccessToken': json['AuthenticateWithExternalIdGameAccessToken'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON(json['AuthenticateWithExternalIdGameAccessToken']),
        'AwAuthData': json['AwAuthData'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataFromJSON(json['AwAuthData']),
        'VkIdLogin': json['VkIdLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSON(json['VkIdLogin']),
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AuthenticationType': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON(value['AuthenticationType']),
        'Game': value['Game'],
        'Locale': value['Locale'],
        'SessionId': value['SessionId'],
        'SteamLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginToJSON(value['SteamLogin']),
        'SteamOpenIdLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSON(value['SteamOpenIdLogin']),
        'EgsLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginToJSON(value['EgsLogin']),
        'GoogleLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSON(value['GoogleLogin']),
        'FacebookLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginToJSON(value['FacebookLogin']),
        'AuthenticateWithExternalIdGameAccessToken': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON(value['AuthenticateWithExternalIdGameAccessToken']),
        'AwAuthData': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataToJSON(value['AwAuthData']),
        'VkIdLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSON(value['VkIdLogin']),
    };
}

